/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iframe_Remote_Style_Guide_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to load style guide: {error}" |
*
* @param {Iframe_Remote_Style_Guide_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_style_guide_failed_toast = /** @type {((inputs: Iframe_Remote_Style_Guide_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Style_Guide_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec du chargement du guide de style : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Styleguide konnte nicht geladen werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile caricare la guida di stile: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось загрузить руководство по стилю: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al cargar la guía de estilo: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`加载样式指南失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`スタイルガイドの読み込みに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`स्टाइल गाइड लोड करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao carregar o guia de estilo: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to load style guide: ${i?.error}`)
});